import { ObjectBuilder } from "../graphQlBuilder/ObjectBuilder.js";
class ReadBuilder {
  constructor(objectBuilder = new ObjectBuilder()) {
    this.objectBuilder = objectBuilder;
  }
  static instantiate(objectBuilder = new ObjectBuilder()) {
    return new ReadBuilder(objectBuilder);
  }
  static instantiateFromFactory(builder) {
    if (typeof builder === "function") {
      return builder(ReadBuilder.instantiate());
    }
    return builder;
  }
  instantiate(objectBuilder = new ObjectBuilder()) {
    return ReadBuilder.instantiate(objectBuilder);
  }
  by(by) {
    return this.instantiate(this.objectBuilder.argument("by", by));
  }
  filter(where) {
    return this.instantiate(this.objectBuilder.argument("filter", where));
  }
  orderBy(orderBy) {
    return this.instantiate(this.objectBuilder.argument("orderBy", orderBy));
  }
  offset(offset) {
    return this.instantiate(this.objectBuilder.argument("offset", offset));
  }
  limit(limit) {
    return this.instantiate(this.objectBuilder.argument("limit", limit));
  }
  skip(offset) {
    return this.instantiate(this.objectBuilder.argument("skip", offset));
  }
  first(limit) {
    return this.instantiate(this.objectBuilder.argument("first", limit));
  }
  column(name) {
    return this.instantiate(this.objectBuilder.field(name));
  }
  inlineFragment(typeName, builder) {
    builder = ReadBuilder.instantiateFromFactory(builder);
    return this.instantiate(this.objectBuilder.inlineFragment(typeName, builder.objectBuilder));
  }
  applyFragment(fragmentName) {
    return this.instantiate(this.objectBuilder.applyFragment(fragmentName));
  }
  reductionRelation(name, builder, alias) {
    return this.relation(name, builder, alias);
  }
  hasOneRelation(name, builder, alias) {
    return this.relation(name, builder, alias);
  }
  hasManyRelation(name, builder, alias) {
    return this.relation(name, builder, alias);
  }
  anyRelation(name, builder, alias) {
    return this.relation(name, builder, alias);
  }
  relation(name, builder, alias) {
    builder = ReadBuilder.instantiateFromFactory(builder);
    const [objectName, objectBuilder] = typeof alias === "string" ? [alias, builder.objectBuilder.name(name)] : [name, builder.objectBuilder];
    return this.instantiate(this.objectBuilder.object(objectName, objectBuilder));
  }
}
export {
  ReadBuilder
};
//# sourceMappingURL=ReadBuilder.js.map
